<script lang="ts" setup>
import randomString from '@/utils/randomString'
import PhotoSwipe from 'photoswipe'
import 'photoswipe/style.css'

const props = defineProps<{
  galleryId?: string
}>()

const container = ref<HTMLDivElement>()
const isOpen = ref(false)
const loaded = ref(false)
const id = ref<string>(props.galleryId || randomString(8))
const img404 = 'https://resource.mfuns.net/image/placeholder/img-404.png'

const _images = ref<PicturePreviewItem[]>([])

onMounted(() => {
  load()
})

let pswp: PhotoSwipe | null = null

const open = (e: MouseEvent, index: number) => {
  e.preventDefault()
  e.stopPropagation()
  pswp = new PhotoSwipe({
    loop: false,
    pinchToClose: false,
    showHideAnimationType: 'zoom',
    preload: [4, 4],
    gallery: '#' + id,
    dataSource: _images.value,
    index,
    zoom: false // 禁用缩放按钮，只使用双指缩放
  })

  pswp.init()

  setTimeout(() => {
    isOpen.value = true
  }, 200)

  pswp.on('close', () => {
    isOpen.value = false
  })
}

async function load() {
  const images = container.value!.getElementsByTagName('img') as any
  const arr = [...images]
  _images.value = await Promise.all(
    arr
      .filter((img) => img.classList.contains('preview'))
      .map(async (img, index) => {
        img.onerror = `this.onerror=null;this.src='${img404}'` as any
        img.alt = img.alt || 'user image'
        const size = await getImgSize(img.src)
        img.onclick = (e: MouseEvent) => open(e, index)
        return {
          src: resizeImg(size.url),
          width: size.width,
          height: size.height,
          alt: img.alt,
          msrc: resizeImg(img.src, 600)
        }
      })
  )
  loaded.value = true
}
</script>

<template>
  <div ref="container" class="m-image-preview">
    <slot />
  </div>
</template>

<style lang="scss">
.pswp__top-bar {
  top: var(--ion-safe-area-top) !important;
}
</style>

<style lang="scss" scoped>
.v-enter-active,
.v-leave-active {
  opacity: 1;
  transition: opacity 2s ease-in-out;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
.m-image-preview {
  :deep(img.preview) {
    cursor: zoom-in;
  }
}
</style>
